import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ALL_PAYMENTS_ORG_UNIT } from "../../../helper/reportsHelper";


type PaymentsOrgUnitFilterProps = {
    value?: string[];
    onChange: (value: string[]) => void;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
export const PaymentsOrgUnitFilter: React.FC<PaymentsOrgUnitFilterProps> = ({
    value,
    onChange,
}) => {
    const { t } = useTranslation();


    const paymentsOrgUnitOptions = ALL_PAYMENTS_ORG_UNIT.map(
        (org_unit) => ({
            value: org_unit.code,
            label: org_unit.name,
        })
    );
    return (
        <SelectBoxWrapper>
            <Select
                mode="multiple"
                allowClear
                placeholder={t("payments.table.column.org_unit")}
                style={{ width: "100%", minWidth: 150 }}
                maxTagCount={1}
                options={paymentsOrgUnitOptions}
                onChange={onChange}
                value={value}
            />
        </SelectBoxWrapper>
    );
};